module.exports = __webpack_public_path__ + "static/media/bg_square-dark-2.986bea7f.jpg";